export default "__VITE_ASSET__BatlKT$y__"